import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { SLIPPAGE_CONFIG } from "#/config/slippage";
const defaultValue = SLIPPAGE_CONFIG.options.midDelta.values[1];

export const midDeltaSlippagePercentageAtom = atomWithStorage<number>(
  "midDeltaSlippage",
  defaultValue,
);

export const useMidDeltaSlippagePercentage = () => {
  const [midDeltaSlippagePercentage, setMidDeltaSlippagePercentage] = useAtom(
    midDeltaSlippagePercentageAtom,
  );

  const midDeltaSlippageFactor = Number(
    (midDeltaSlippagePercentage / 100).toFixed(2),
  );
  return {
    midDeltaSlippagePercentage,
    midDeltaSlippageFactor,
    setMidDeltaSlippagePercentage,
  };
};
